import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { UserModel as Model } from './Model'


export const MODULE_NAME = 'users'

export const USERS_ROUTES = Object.freeze({
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,

  PROFILE: `${MODULE_NAME}.profile`,
})

export const MENU = {
  id: USERS_ROUTES.LAYOUT,
  route: { name: USERS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-account-group-outline',
}

export const createUsersModalPassword = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersModalPassword" */
    './components/UsersModalPassword.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createUsersModalChangeStatus = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersModalChangeStatus" */
    './components/UsersModalChangeStatus.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createUploadPermissionsFile = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersModalUploadPermissionsFile" */
    './components/UsersModalUploadPermissionsFile.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createUploadUsersFile = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersModalUploadUsersFile" */
    './components/UsersModalUploadUsersFile.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createUploadUsersActivityFile = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersActivityModalUploadUsersFile" */
    './components/UsersActivityModalUploadUsersFile.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createUploadPermissionGroupsFile = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersActivityModalUploadUsersFile" */
    './components/UsersModalUploadPermissionGroupsFile.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createExportUsersActivityModal = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UsersExportActivityModal" */
    './components/UsersExportActivityModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

